import { FC } from 'react';

import { SFHeaderFooterCategoryFooterViewModel } from '@api/index';
import useLockedBody from '@hooks/useLockedBody';

import { StyledDrawer } from './NavigationDrawerStyle';
import HeaderMile from '../HeaderMile';
import MobileCollapseMenu from '../MobileCollapseMenu';

interface INavigationDrawer {
  data: SFHeaderFooterCategoryFooterViewModel['header'];
  isVisible: boolean;
  onClose: () => void;
}

const NavigationDrawer: FC<INavigationDrawer> = ({
  data,
  isVisible = false,
  onClose,
}) => {
  useLockedBody(isVisible);

  return (
    <StyledDrawer
      onClose={onClose}
      open={isVisible}
      destroyOnHidden={true}
      styles={{
        wrapper: {
          height: '100%',
          width: '100%',
          top: '60px',
          boxShadow: 'none',
        },
      }}
      mask={false}
      footer={<HeaderMile />}
    >
      <MobileCollapseMenu
        data={data}
        isMenuOpen={true}
        handleMenuOpen={onClose}
      />
    </StyledDrawer>
  );
};

export default NavigationDrawer;
